import { useMediaQuery, useTheme } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {
  ComplianceCard, ComplianceCardButton, ComplianceCardContent, ComplianceCardImage,
} from '../styles/ComplianceCardWithInnerAction.style';
import { ComplianceCardProps } from '../types/ComplianceCard.types';

export const ComplianceCardWithInnerAction = (props: ComplianceCardProps) => {
  const {
    bgColor,
    onClick,
    title,
    mainText,
    linkText,
    img,
    index,
  } = props;

  const { breakpoints } = useTheme();
  const isPhone = useMediaQuery(breakpoints.down('sm'));

  return (
    <ComplianceCard item large={index === 0}>
      <ComplianceCardImage><img src={img} alt={title} /></ComplianceCardImage>
      <ComplianceCardContent >
        <Typography variant="h5">{title}</Typography>
        <Typography component={'div'} variant='body1'>{mainText}</Typography>

        <ComplianceCardButton
          variant="contained"
          color={bgColor as ButtonProps['color']}
          type="submit"
          role="link"
          onClick={onClick}
          fullWidth={isPhone}
          rightPosition={index === 0}
        >
          {linkText}
        </ComplianceCardButton>
      </ComplianceCardContent>
    </ComplianceCard>
  );
};
